import ModuleFooter from './ModuleFooter.vue';

export default ModuleFooter;



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulefooter/index.ts